<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup light-container-tray">
	<!-- header -->
	<div class="light-container__header light-container-tray__header">Procore Link Creation</div>
	<div>You have successfully created a Procore linked constraint. Here are the details:</div>

	<!-- content -->
	<ng-template [loadingBlocker]="loadingObservable | async"></ng-template>
	<div class="light-container-popup__content">
		<div class="light-container-popup__content-item light-container-popup__content-item--procore">
			<div class="procore-status-item">
				RFI#
				<div class="light-container-popup__content-item-data">{{ (procoreRfi$ | async)?.id }}</div>
			</div>

			<div>
				Subject
				<div class="light-container-popup__content-item-data">{{ (procoreRfi$ | async)?.subject }}</div>
			</div>

			<div>
				Status
				<div class="light-container-popup__content-item-data">
					{{ (procoreRfi$ | async)?.translated_status }}
				</div>
			</div>

			<div class="procore-status-item-container">
				Due Date
				<div class="light-container-popup__content-item-data">
					{{ (procoreRfi$ | async)?.due_date || 'No Due Date' }}
				</div>
			</div>

			<div class="procore-status-item-container">
				Assigned To
				<div class="light-container-popup__content-item-data">
					{{ (procoreRfi$ | async)?.assignee?.name || 'Not Assigned' }}
				</div>
			</div>

			<div class="procore-status-item-container">
				Created By
				<div class="light-container-popup__content-item-data">
					{{ (procoreRfi$ | async)?.created_by?.name || 'Unknown' }}
				</div>
			</div>

			<div class="procore-status-item-container procore-status-description-container">
				Questions
				<ng-template ngFor let-question [ngForOf]="(procoreRfi$ | async)?.questions">
					<div class="procore-question">
						{{ question.plain_text_body }}
					</div>
					<div
						*ngIf="!question.answers || !question.answers.length"
						class="light-container-popup__content-item-data"
					>
						No Responses to this question
					</div>
					<div *ngFor="let answer of question.answers" class="light-container-popup__content-item-data">
						{{ answer.plain_text_body }}
					</div>
				</ng-template>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<div class="light-container-popup__footer light-container-popup__footer-three-buttons">
		<div>
			<button class="legacy-button btn--white close-button" (click)="deleteLink()" automationId="deleteLink">
				Delete Link
			</button>
		</div>
		<div class="light-container-popup__footer-buttons-right">
			<button class="legacy-button btn--white close-button" (click)="close()" automationId="closeButton">
				Close
			</button>
			<button class="legacy-button btn--blue" (click)="goToRFI()" automationId="viewInProcore">
				View in Procore
			</button>
		</div>
	</div>
</div>
